import React from 'react'
import 'loyal-design-system/assets/css/atoms/placeholder.css'
const FooterPlaceholder = () => (
  <footer>
    <div className='container-footer bg-brand-4 container-fluid py-4'>
      <div className='container py-1'>
        <div className='row'>
          <div className='address col-12 col-md-6 align-self-center'>
            <div className='row'>
              <div className='col-12 col-md-3 pl-0 pr-2'>
                <div className='row'>
                  <div className='col-12 pt-3 pb-2 bg-ui-3 radius opacity' />
                </div>
              </div>
              <div className='col-12 col-md-8 align-self-center mt-3 mt-md-0'>
                <div className='row mx-0 shimmer'>
                  <div className='col-8 py-half bg-ui-3 radius opacity' />
                </div>
                <div className='row mx-0 shimmer mt-1'>
                  <div className='col-10 py-half bg-ui-3 radius opacity' />
                </div>
              </div>
            </div>
          </div>
          <div className='app col-12 col-md-6'>
            <div className='row'>
              <div className='col-12 col-md-6 txt-right downloadit-app txt-circular-book color-ui-white txt-center txt-md-right mt-3 mt-md-0 align-self-center'>
                <div className='row mx-0 shimmer'>
                  <div className='col-10 py-half bg-ui-3 radius opacity' />
                </div>
              </div>
              <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                <div className='row mx-0'>
                  <div className='col-12 pt-3 pb-2 bg-ui-3 radius opacity' />
                </div>
              </div>
              <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                <div className='row mx-0'>
                  <div className='col-12 pt-3 pb-2 bg-ui-3 radius opacity' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className='container-footer bg-ui-1 container-fluid'>
      <div className='container'>
        <div className='links col-12 px-0 py-3'>
          <ul className='row'>
            <li className='col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'>
              <div className='row mx-0 shimmer'>
                <div className='col-10 py-half bg-ui-3 radius opacity' />
              </div>
            </li>
            <li className='col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'>
              <div className='row mx-0 shimmer'>
                <div className='col-10 py-half bg-ui-3 radius opacity' />
              </div>
            </li>
            <li className='col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'>
              <div className='row mx-0 shimmer'>
                <div className='col-10 py-half bg-ui-3 radius opacity' />
              </div>
            </li>
            <li className='col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'>
              <div className='row mx-0 shimmer'>
                <div className='col-10 py-half bg-ui-3 radius opacity' />
              </div>
            </li>
            <li className='col-12 col-md-2 pr-4 txt-center txt-md-left my-1 my-md-0'>
              <div className='row mx-0 shimmer'>
                <div className='col-10 py-half bg-ui-3 radius opacity' />
              </div>
            </li>
          </ul>
        </div>
        <div className='legal col-12 px-0 py-3'>
          <div className='row mx-0 shimmer mb-1'>
            <div className='col-12 py-half bg-ui-3 radius opacity' />
          </div>
          <div className='row mx-0 shimmer'>
            <div className='col-8 py-half bg-ui-3 radius opacity' />
          </div>
        </div>
      </div>
    </div>
  </footer>
)

export default FooterPlaceholder
